import axios from 'axios';

export default {
  state: {
    active: null,
    pins: null,
    page: 0,
    users: null
  },
  mutations: {
    setPins(state, pins) {
      state.pins = pins;
    },
    morePins(state, pins) {
      if (pins && pins.length > 0) {
        state.pins = state.pins.concat(pins)
      }
    },
    addPin(state, pin) {
      state.pins.unshift(pin);
    },
    deletePinComment(state, comment) {
      let finded = state.pins.find(pin => pin.id == comment.pin_id);
      let index = state.pins.indexOf(finded);
      let indexComment = state.pins[index].comments.indexOf(comment);
      state.pins[index].comments.splice(indexComment, 1);
    },
    deletePin(state, id) {
      let finded = state.pins.find(pin => pin.id == id);
      let index = state.pins.indexOf(finded);
      state.pins.splice(index, 1);
    },
    nextPagePins(state) {
      state.page++;
    },
    setActivePin(state, active) {
      state.active = active;
    },
    setModalUsers(state, users) {
      state.users = users;
    }
  },
  actions: {
    setModalUsers({ commit }, users) {
      commit('setModalUsers', users)
    },
    async createPin({ dispatch, commit }, params) {
      let result;
      try {
        await axios
          .post(`/api/pins/add`, params)
          .then((response) => {
            result = response.data;
            commit('addPin', result);
          })
          .catch((error) => {
            dispatch('addError', { message: error.response.data });
          });
      } catch (error) {
        console.error(error);
      }
      return result;
    },
    async updatePin({ commit }, params) {
      let result;
      await axios
        .post(`/api/pins/edit`, params)
        .then((response) => {
          commit
          result = response.data;
        })
      return result;
    },
    async sendPinUnLike({ commit }, params) {
      let result;
      await axios
        .post(`/api/pins/unlike`, params)
        .then((response) => {
          commit;
          result = response.data;
        })
      return result;
    },
    async sendPinLike({ commit }, params) {
      let result;
      await axios
        .post(`/api/pins/like`, params)
        .then((response) => {
          commit;
          result = response.data;
        })
      return result;
    },
    async sendPinCommentLike({ commit }, params) {
      let result;
      await axios
        .post(`/api/pins/comment/like`, params)
        .then((response) => {
          commit;
          result = response.data;
        })
      return result;
    },
    async sendPinCommentUnLike({ commit }, params) {
      let result;
      await axios
        .post(`/api/pins/comment/unlike`, params)
        .then((response) => {
          commit;
          result = response.data;
        })
      return result;
    },
    async fetchPin({ commit }, params) {
      let result;
      await axios
        .post(`/api/pins/pin`, params)
        .then((response) => {
          commit('setActivePin', response.data)
          result = response.data;
        })
      return result;
    },
    async sendPinView({commit}, params) {
      let result;
      await axios
        .post(`/api/pins/view`, params)
        .then((response) => {
          commit
          result = response.data;
        })
      return result;
    },
    async clearPins({ commit }) {
      commit('setPins', null)
    },
    async getPins({ dispatch, commit }, params) {
      let result;
      await axios
        .post(`/api/pins`, params)
        .then((response) => {
          result = response.data;
          params.more ? commit('morePins', result) : commit('setPins', result);
        })
        .catch((error) => {
          dispatch('addError', { message: error.response.data });
        });
      return result;
    },
    async deletePin({ dispatch, commit }, params) {
      let result;
      await axios
        .post(`/api/pins/delete`, params)
        .then((response) => {
          commit('deletePin', params.id);
          result = response.data;
        })
        .catch((error) => {
          dispatch('addError', { message: error.response.data });
        });
      return result;
    },
    hidePin({commit}, params) {
      commit('deletePin', params.id_pin);
    },
    async deletePinComment({ commit }, params) {
      let result;
      await axios
        .post(`/api/pins/comment/delete`, {id: params.id})
        .then(response => {
          commit('deletePinComment', params);
          result = response.data;
        })
      return result;
    },
    setActivePin({ commit }, active) {
      commit('setActivePinSimple', active);
    },
  },
  getters: {
    getActivePin: (s) => s.active,
    getPins: (s) => s.pins,
    getPinsPage: (s) => s.page,
    getModalUsers: (s) => s.users,
  },
};
